import type { UnitSystem } from '@trainme/api/client';
import { useSettingsStore } from '@/app/stores/settingsStore';

export function useUnitSystem(): UnitSystem {
  const { trainingSettings } = useSettingsStore();
  return trainingSettings?.unitSystem ?? 'scientific';
}
